module.exports = __webpack_public_path__ + "img/Dachi Imedadze.57daa908.png";